"use client";

import { useEffect, useState } from "react";

/** Indicatore dei crediti Runway nella topbar (refresh ogni 60s). */
export default function RunwayCredits() {
  const [credits, setCredits] = useState<number | null | undefined>(undefined);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetch("/api/runway/credits")
        .then((r) => r.json())
        .then((d) => {
          if (alive) setCredits(d.credits ?? null);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (credits === undefined) return null; // primo caricamento

  const low = typeof credits === "number" && credits < 1000;
  return (
    <span
      className="ml-auto inline-flex items-center gap-1.5 rounded border border-edge bg-panel px-2.5 py-1 text-xs"
      title="Crediti Runway residui (organizzazione)"
    >
      <span className="text-ink-3">Runway</span>
      <span className={low ? "font-semibold text-orange-400" : "font-semibold text-ink"}>
        {credits === null ? "—" : credits.toLocaleString("it-IT")}
      </span>
      <span className="text-ink-3">cr</span>
    </span>
  );
}
